<svg preserveAspectRatio="none" style="background: black; width: 100%; height: 100%" viewBox="-10 -10 120 120">
  <path [attr.d]="path" #pathElement stroke-linecap="round" vector-effect="non-scaling-stroke" stroke="darkred" stroke-width="3" fill="none"></path>
</svg>
